// extracted by mini-css-extract-plugin
module.exports =  {"tooltipContainer":"tooltipContainer___GZd9m","tooltip":"tooltip___RZusc"};